import Db from "./db";
import h from "./html";
import { PasswordReset } from "../../srv/bindings/PasswordReset";

export default function PasswordReset({ db }: { db: Db }) {
  const pathname = h.pathnameState();
  let pwReset = h.state<"loading" | "error" | PasswordReset>("loading");
  fetch(
    `${process.env.SERVER_PATH}/password_reset/${pathname.val.split("/reset/")[1]}`,
    {
      credentials: "include",
    },
  ).then(async (res) => {
    const json = await res.json();
    pwReset.val = json;
  });

  const pending = h.state(false);
  const error = h.state<string | null>(null);
  return (
    <div className="min-w-screen min-h-screen flex flex-col sm:flex-row">
      <div className="sm:w-[40%] self-stretch bg-fairy-600 text-fairy-50 flex gap-2">
        <div className="grow" />
        <h1 className="mb py-4 text-4xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl 2xl:text-8xl font-bold text-amber-300 self-center">
          Polyday
        </h1>
        <div className="grow" />
      </div>
      <div className="flex grow flex-col">
        <div className="grow" />
        <form
          className="grid sm:grid-cols-[auto_1fr] gap-2 grid-cols-1 max-w-xl mx-auto items-center w-96"
          onsubmit={async (ev: SubmitEvent) => {
            ev.preventDefault();
            pending.val = true;
            error.val = null;
            try {
              const formData = new FormData(ev.target as HTMLFormElement);
              if (pwReset.val === "loading" || pwReset.val === "error") {
                throw new Error("Invalid state.");
              }
              const resetCode = pwReset.val.resetCode;
              const password = formData.get("password") as string;
              if (password === "") {
                error.val = "Please enter a username and password";
                return;
              }

              db.reset(resetCode, password).then(async (res) => {
                if (res === 200) {
                  pathname.val = "/";
                }
              });
            } catch (err) {
              error.val =
                "Something went wrong. Please check your Internet connection";
            } finally {
              pending.val = false;
            }
          }}
        >
          <label htmlFor="login-email" className="sm:mt-0 mt-2">
            Email
          </label>
          <input
            className="border-2 p-2 bg-fairy-400 text-fairy-50 border-fairy-400 rounded-md placeholder-fairy-100"
            id="login-email"
            autofocus
            disabled
            type="email"
            value={() => {
              if (pwReset.val === "loading") {
                return "";
              }
              if (pwReset.val === "error") {
                return "Error";
              }
              return pwReset.val.email;
            }}
          />
          <label htmlFor="login-password" className="sm:mt-0 mt-2">
            New password
          </label>
          <input
            className="border-2 p-2 bg-fairy-400 text-fairy-50 border-fairy-400 rounded-md placeholder-fairy-100"
            id="login-password"
            placeholder="hunter2"
            autofocus
            name="password"
            type="password"
            disabled={() => pending.val}
          />
          <div className="col-span-2 text-red-400 font-bold">
            {() => error.val ?? " "}
          </div>
          <div />
          <div className="flex mt-2 mb-2 flex-col">
            <div className="grow" />
            <button
              className="p-2 bg-fairy-500 hover:bg-fairy-300 text-fairy-50 border-fairy-400 border-2 rounded-md px-8 disabled:bg-fairy-300"
              disabled={() =>
                pending.val ||
                pwReset.val === "loading" ||
                pwReset.val === "error"
              }
            >
              {() => (pending.val ? "Loading…" : "Reset password")}
            </button>
          </div>
        </form>
        <div className="grow" />
      </div>
    </div>
  );
}
